export default "__VITE_ASSET__bf9ff5b2__"